<template lang="pug">
.other-user-group-member-detail-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc hide-footer)
    .other-user-group-member-detail-modal-table
      .thead
        .header-line
          .th.sender-type 送信手段
          .th.name ユーザー名
          .th.tel 電話番号
          .th.organization 所属
          .th.room-schedule-function 空室／空床情報
          .th.operation 登録情報
          .th.send-message 登録確認
      .tbody
        .body-line(v-for="member in _members")
          // 送信手段
          .td.sender-type.center {{ convertSenderType(member.senderType) }}
          // ユーザー名
          .td.name {{ member.memberName }}
          // 電話番号
          .td.tel {{ member.memberTel }}
          // 所属
          .td.organization(v-if="member.memberOrganization") {{ member.memberOrganization }}
          .td.organization(v-else) 未設定
          // 空室情報
          template(v-if="member.senderType == 1")
            .td.room-schedule-function －
          template(v-else)
            .td.room-schedule-function.used(v-if="member.otherUserPermittedFunctions.vacancy") 使用可
            .td.room-schedule-function.unused(v-else) 使用不可
          // 登録情報
          .td.operation.center
            button.btn.edit-btn.mr-1(@click="onEdit(member)") 修正
            button.btn.delete-btn.mr-1(@click="onDelete(member)") 削除
            button.btn.transfer-btn(@click="onTransferMember(member, $event)") 他施設へ移動／コピー
          // 登録確認
          .td.send-message.center
            button.btn.testmail-btn(v-if="member.senderType == 1" @click="onSendMessage(member)") 確認送信
    .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap.mt-3
      //- 検索
      .search-filter.d-flex.mr-1.align-items-center.mr-2
        b-input-group.search-filter-input-group.mr-1(size="md")
          b-input-group-prepend
            b-input-group-text.search-filter-icon
              .search-icon
          b-form-input.search-filter-input(v-model="searchWord" type="search" placeholder="検索ワードを入力してください")
        HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="other-user-group-member-detail-modal-help" title="検索項目について")
          template(v-slot:text)
            div 検索項目は以下になります。
            div ・施設関係者メンバー名
</template>

<script lang="ts">
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import OtherUserGroup from "@/commons/models/OtherUserGroup";
import { SenderType } from "@/commons/models/Resident";

import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * ### 施設関係者グループユーザー詳細表示モーダル
 */
@Component({
  components: {
    HelpIcon
  }
})
export default class OtherUserGroupMemberDetailModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /**
   * 施設関係者グループユーザー
   */
  @Prop({
    default: () => {
      return [];
    }
  })
  members!: Array<OtherUserGroup>;

  @Prop()
  modelShow!: boolean;

  searchWord: string = "";

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * モーダルの表示/非表示が切り替わるタイミングで検索ワードを初期化する
   */
  @Watch("value")
  public onValueChanged(newValue: boolean): void {
    if (newValue) {
      this.searchWord = "";
    }
  }

  get _members(): Array<OtherUserGroup> {
    // 検索ワードが入力されている場合、メンバー名のフィルタリングを実施する
    if (this.searchWord) {
      return this.members.filter((member: OtherUserGroup) => {
        return member.memberName.includes(this.searchWord);
      });
    }

    return this.members;
  }

  /**
   * ### 送信手段文字列を返す
   */
  public convertSenderType(senderType: SenderType): string {
    if (senderType == SenderType.LINE) {
      return "LINE";
    } else if (senderType == SenderType.MAIL) {
      return "メール";
    } else {
      return "";
    }
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(member: OtherUserGroup): void {
    this.$emit("onEdit", member);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(member: OtherUserGroup): void {
    this.$emit("onDelete", member);
    return;
  }

  /**
   * ### 施設関係者メンバーの移動／コピーボタン押下イベント
   */
  public onTransferMember(member: OtherUserGroup, bvModalEvent: any): void {
    bvModalEvent.preventDefault();
    this.$emit("onTransferMember", member);
    return;
  }

  /**
   * ### 確認送信ボタン押下イベント
   */
  public onSendMessage(member: OtherUserGroup): void {
    this.$emit("onSendMessage", member);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
.used {
  color: $font-key-color;
  font-weight: bold;
}
.unused {
  color: $font-disable-font-color;
}
</style>
